export default "/react/sberAds-897e6685.svg";